import { createDispatchFunction } from 'shared/helpers';
import { partial } from 'lodash';
import OnlineTestingService from './OnlineTestingService';

// Actions
const GET_ONLINE_REGS = 'taskManagement/GET_ONLINE_REGS';
const GET_ONLINE_PSI_REGS = 'taskManagement/GET_ONLINE_PSI_REGS';
const GET_INDIVIDUAL_ONLINE_REG = 'taskManagement/GET_INDIVIDUAL_ONLINE_REG';
const GET_INDIVIDUAL_ONLINE_PSI_REG = 'taskManagement/GET_INDIVIDUAL_ONLINE_PSI_REG';

const initialState = {
  onlineRegs: [],
  onlinePsiRegs: [],
  loadingRegs: false,
};

// Reducer
export default function onlineTestingReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ONLINE_REGS:
      return {
        ...state,
        onlineRegs: action.result.data || [],
        loadingRegs: action.result.loading,
      };
      case GET_ONLINE_PSI_REGS:
        return {
          ...state,
          onlinePsiRegs: action.result.data || [],
          loadingPsiRegs: action.result.loading,
        };
    case GET_INDIVIDUAL_ONLINE_REG:
      const newRegs = action.result.data ? state.onlineRegs.map((reg) => (reg.id === action.result.data.id) ? action.result.data : reg) : [];

      return {
        ...state,
        onlineRegs: newRegs.length ? newRegs : state.onlineRegs,
      };
    case GET_INDIVIDUAL_ONLINE_REG:
    const newPsiRegs = action.result.data ? state.onlinePsiRegs.map((reg) => (reg.id === action.result.data.id) ? action.result.data : reg) : [];

    return {
      ...state,
      onlinePsiRegs: newPsiRegs.length ? newPsiRegs : state.onlinePsiRegs,
    };
    default:
      return state;
  }
}

// Action Creators

export function getOnlineRegsAction(result) {
  return { type: GET_ONLINE_REGS, result };
}

export function getOnlinePsiRegsAction(result) {
  return { type: GET_ONLINE_PSI_REGS, result };
}

export function getIndividualOnlineRegAction(result) {
  return { type: GET_INDIVIDUAL_ONLINE_REG, result };
}

export function getIndividualOnlinePsiRegAction(result) {
  return { type: GET_INDIVIDUAL_ONLINE_PSI_REG, result };
}

// Action dispatcher functions

export function getOnlineRegs(roomId, regTypeId = null) {
  return createDispatchFunction(
    partial(OnlineTestingService.getOnlineRegs, roomId, regTypeId),
    getOnlineRegsAction
  );
}

export function getOnlinePsiRegs(roomId) {
  return createDispatchFunction(
    partial(OnlineTestingService.getOnlinePsiRegs, roomId),
    getOnlinePsiRegsAction
  );
}

export function getOnlineIndividualReg(regId, includeProgressFlag) {
  return createDispatchFunction(
    partial(OnlineTestingService.getIndividualOnlineReg, regId, includeProgressFlag),
    getIndividualOnlineRegAction
  );
}

export function getOnlineIndividualPsiReg(regId, forceRefresh) {
  return createDispatchFunction(
    partial(OnlineTestingService.getIndividualPsiOnlineReg, regId, forceRefresh),
    getIndividualOnlinePsiRegAction
  );
};